import { render, staticRenderFns } from "./ConcatenationItem.vue?vue&type=template&id=9b4925b8&scoped=true"
import script from "./ConcatenationItem.vue?vue&type=script&lang=js"
export * from "./ConcatenationItem.vue?vue&type=script&lang=js"
import style0 from "./ConcatenationItem.vue?vue&type=style&index=0&id=9b4925b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4925b8",
  null
  
)

export default component.exports